import api from "../../APIIntercepter";

async function getStudentsAPI(classId) {
  const url = `/user/admin/student/class/${classId}`;
  const res = await api.get(url);
  return res.data;
}

async function getStudentsByClassStatusAndDateAPI(classId, status, date) {
  const url = `/user/admin/student/class/${classId}/${status}/${date}`;
  const res = await api.get(url);
  return res.data;
}

async function getStudentByIdAPI(studentId) {
  const res = await api.get(`/user/admin/student/${studentId}`);
  return res.data;
}

async function updateStudentAPI(params) {
  const res = await api.put("/user/admin/student/updateById", params);
  return res.data;
}

async function changeStudentPasswordAPI(params) {
  const res = await api.put("/user/admin/student/changePassword", params);
  return res.data;
}

async function changeStudentMobileNumberAPI(params) {
  const res = await api.put("/user/admin/student/changeMobileNumber", params);
  return res.data;
}

async function getStudentPaymentHistoryAPI(studentId) {
  const res = await api.get(`/user/admin/payment/student/${studentId}`);
  return res.data;
}

async function removeStudentAPI(studentId) {
  const res = await api.delete(`/user/admin/student/remove/${studentId}`);
  return res.data;
}

async function blockStudentAPI(studentId) {
  const res = await api.post(`/user/admin/blockUser/${studentId}`, {});
  return res.data;
}

async function giveFreeAccessAPI(params) {
  const url = `/studentassign/admin/free`;
  const res = await api.post(url, params);
  return res.data;
}

async function unassignAccessAPI(params) {
  const url = `/studentassign/admin/unassign`;
  const res = await api.post(url, params);
  return res.data;
}

async function getStudentByNumberAPI(number) {
  const res = await api.get(`/user/admin/${number}`);
  return res.data;
}

export {
  getStudentsAPI,
  getStudentByIdAPI,
  updateStudentAPI,
  changeStudentPasswordAPI,
  getStudentPaymentHistoryAPI,
  changeStudentMobileNumberAPI,
  removeStudentAPI,
  blockStudentAPI,
  giveFreeAccessAPI,
  getStudentByNumberAPI,
  getStudentsByClassStatusAndDateAPI,
  unassignAccessAPI
};
